import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-building-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_522_2339)">
        <path
          d="M5.25 6.75C6.90685 6.75 8.25 5.40685 8.25 3.75C8.25 2.09315 6.90685 0.75 5.25 0.75C3.59315 0.75 2.25 2.09315 2.25 3.75C2.25 5.40685 3.59315 6.75 5.25 6.75Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.5 23.25L8.25 15.75H9.75V12.75C9.75 11.5565 9.27589 10.4119 8.43198 9.56802C7.58807 8.72411 6.44347 8.25 5.25 8.25C4.05653 8.25 2.91193 8.72411 2.06802 9.56802C1.22411 10.4119 0.75 11.5565 0.75 12.75V15.75H2.25L3 23.25H7.5Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23.25 5.25C23.2534 6.99649 22.6605 8.69182 21.5695 10.0556C20.4785 11.4194 18.9546 12.3699 17.25 12.75C15.5454 12.3699 14.0215 11.4194 12.9305 10.0556C11.8395 8.69182 11.2466 6.99649 11.25 5.25V2.25C11.25 1.85218 11.408 1.47064 11.6893 1.18934C11.9706 0.908035 12.3522 0.75 12.75 0.75H21.75C22.1478 0.75 22.5294 0.908035 22.8107 1.18934C23.092 1.47064 23.25 1.85218 23.25 2.25V5.25Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.25 4.5V9"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 6.75H19.5"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_522_2339">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class BusinessRcProfessionalInsuranceIconComponent extends BaseIconComponent {}
